<template>
  <div class="setScript">
    <div class="contentItem">
      <div class="itemTitle">定义input对象</div>
      <script-key-value-pairs
        :list="inputs"
        :workflow-var-groups="workflowVarGroups"
        addItemText="+ key-value pairs"
      ></script-key-value-pairs>
    </div>
    <div class="contentItem">
      <div class="itemTitle">
        代码块
        <el-tooltip effect="dark" placement="bottom" content="">
          <div slot="content">
            代码脚本编写语言为javascript
          </div>
          <i class="el-icon-info"></i>
        </el-tooltip>
      </div>
      <div :class="{ 'full-screen-codemirror': fullScreen }">
        <el-tooltip class="item" effect="dark" content="插入函数" placement="bottom">
          <span
            @click="openFuncDialog"
            class="pointer"
            style="position: absolute; z-index: 10; right: 50px; font-size: 24px;"
          >
            <svg-icon icon-class="workflow_script_function"></svg-icon>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="fullScreen ? '退出全屏' : '全屏'"
          placement="bottom"
        >
          <i
            class="el-icon-full-screen pointer"
            style="position: absolute; z-index: 10; right: 30px; margin-top: 6px; font-size: 16px;"
            @click="fullscreen"
          ></i>
        </el-tooltip>
        <codemirror ref="codeInfo" v-model="tempNodeData.scriptStr" :options="cmOptions" />
      </div>
    </div>
    <div class="contentItem">
      <div class="itemTitle">Output对象参数列表</div>
      <output-params ref="outputParams" :output-params="tempNodeData.output"></output-params>
    </div>
    <div class="contentItem">
      <div class="itemTitle">是否作为http返回值</div>
      <el-checkbox
        :value="tempNodeData.type === 'HTTP_RES'"
        @input="$set(tempNodeData, 'type', $event ? 'HTTP_RES' : null)"
      >
        是
      </el-checkbox>
    </div>
    <base-dialog :visible.sync="funcDialogVisible" class="setting-func-dialog">
      <template v-slot:header>插入函数</template>
      <tree-select
        v-model="code"
        :group-list="functions"
        explain
        style="margin: 40px 0"
      ></tree-select>
      <template v-slot:footer>
        <span class="dialog-footer">
          <base-button @click="funcDialogVisible = false">取消</base-button>
          <base-button type="primary" @click="insertCode">确认</base-button>
        </span>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror"
import "codemirror/lib/codemirror.css"
// language
import "codemirror/mode/javascript/javascript.js"
// theme css
import "codemirror/theme/idea.css"
// require active-line.js
import "codemirror/addon/selection/active-line.js"
// styleSelectedText
import "codemirror/addon/selection/mark-selection.js"
import "codemirror/addon/search/searchcursor.js"
import { deepClone } from "@/utils/common"
import ScriptKeyValuePairs from "../components/ScriptKeyValuePairs"
import OutputParams from "./OutputParams"
import mixin from "../components/setHttpRequest/mixin"
import BaseButton from "@/components/UIComponents/Button"
import TreeSelect from "@/components/UIComponents/TreeSelect"
import { functions } from "@/views/Backend/AdminEdit/Workflow/components/static"
import { transOldExpr } from "@/utils/workFlow"
import BaseDialog from "@/components/UIComponents/BaseDialog"

export default {
  name: "setScript",
  components: { BaseDialog, TreeSelect, ScriptKeyValuePairs, codemirror, OutputParams, BaseButton },
  props: {
    nodeInfo: Object,
    workflowVarGroups: Array
  },
  mixins: [mixin],
  data() {
    return {
      functions,
      tempNodeData: {},
      inputs: [],
      cmOptions: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: "text/javascript",
        lineWrapping: true,
        theme: "idea"
      },
      fullScreen: false,
      funcDialogVisible: false,
      code: ""
    }
  },
  created() {
    this.tempNodeData = deepClone(this.nodeInfo).data
    this.initialData()
  },
  methods: {
    initialData() {
      // input
      for (let key in this.tempNodeData.input) {
        this.inputs.push({
          key,
          value: {
            inFlow: false,
            label: transOldExpr(this.tempNodeData.input[key]),
            value: transOldExpr(this.tempNodeData.input[key])
          }
        })
      }
    },
    // 输出前的校验
    beforeOutput() {
      // input
      if (!this.verifyPairs(this.inputs, "submit", " 定义input对象 ")) return false
      // scriptStr
      if (!this.tempNodeData.scriptStr) {
        this.$notify.warning({
          title: "提示",
          message: "代码块不为空"
        })
        return false
      }
      // output
      return this.$refs.outputParams.validate()
    },
    output() {
      if (!this.beforeOutput()) return
      // input
      this.tempNodeData.input = this.inputs.reduce((acc, cur) => {
        acc[cur.key] = cur.value.value
        return acc
      }, {})
      // output
      this.tempNodeData.output = this.$refs.outputParams.getValue()
      return this.tempNodeData
    },
    fullscreen() {
      this.fullScreen = !this.fullScreen
    },
    openFuncDialog() {
      this.code = ""
      this.funcDialogVisible = true
    },
    insertCode() {
      this.funcDialogVisible = false
      let position1 = this.$refs.codeInfo.codemirror.getCursor()
      let position2 = {}
      position2.line = position1.line
      position2.ch = position1.ch
      this.$refs.codeInfo.codemirror.replaceRange(this.code, position2)
    }
  }
}
</script>

<style lang="scss">
.setScript {
  .contentItem {
    .itemTitle {
      margin-bottom: 10px;
    }
  }
  .vue-codemirror {
    border: 1px solid #dcdfe6;
  }
  .full-screen-codemirror {
    left: 0;
    top: 0;
    z-index: 100;
    position: fixed !important;
    width: 100vw !important;
    height: 100vh !important;
    .CodeMirror {
      height: 100vh !important;
    }
  }
}
</style>
